import type { BadgeProps } from '@/dsComponents/Badge';
import type { WorkerDetail } from '@/modules/worker/types';
import type { JobExperience } from '@/types/job';

export interface WorkerJobEditorJob {
	jobId: string;
	degreeLevel?: string;
	experience?: JobExperience | null;
}

export interface WorkerJobFormatted {
	jobId: string;
	name: string;
	degreeLevel?: string;
	degreeLevelLabel?: string;
	experience?: JobExperience | null;
	experienceLabel?: BadgeProps;
	experienceText?: string;
}

export interface WorkerJobsEditorProps {
	worker: WorkerDetail;
	refreshWorker?: () => Promise<void>;
	readonly: boolean;
	asideLayout?: boolean;
}

export const WORKER_JOB_EDITOR_INITIAL: WorkerJobEditorJob = {
	jobId: '',
	degreeLevel: '',
	experience: null,
};
